import { createContext, useContext, useEffect, useState } from 'react';

const TiktokContext = createContext();

export const TiktokProvider = ({ children }) => {

  /*
   * TikTok "Click ID"
   * https://ads.tiktok.com/help/article/tiktok-click-id?lang=en
   */

  // LOCAL STORAGE

  const KEY_CLICK_ID = 'tiktok_click_id';

  const [ tiktokClickId, setTiktokClickId ] = useState(() => {
    return localStorage.getItem(KEY_CLICK_ID) || '';
  });

  useEffect(() => {
    localStorage.setItem(KEY_CLICK_ID, tiktokClickId || '');
  }, [tiktokClickId]);

  // URL PARAMETER

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const value = params.get('ttclid');
    if (value) {
      setTiktokClickId(value);
    }
  }, []);

  /*
   * Final context
   */

  const context = {
    tiktokClickId, setTiktokClickId,
  };

  return (
    <TiktokContext.Provider value={context}>
      {children}
    </TiktokContext.Provider>
  );
};

export const useTiktokContext = () => useContext(TiktokContext);

export const tiktokPixel = {
  track: (eventName, eventProps, options ) => {
    console.log([eventName, eventProps, options]);
    if (window.ttq && typeof window.ttq.track === 'function') {
      window.ttq.track(eventName, eventProps, options);
    }
  },
};